export class Errors {
  errors: Error[];
}
